"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputField = void 0;
const react_1 = __importStar(require("react"));
require("./InputField.scss");
const InputField_scss_json_1 = __importDefault(require("./InputField.scss.json"));
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const Input_1 = require("lincd-mui-base/lib/components/Input");
// export interface InputFieldProps extends InputProps> {
const InputSlot = () => {
    return react_1.default.createElement("input", { className: InputField_scss_json_1.default.input });
};
const InputField = (_a) => {
    var { name, type, label, placeholder, helperText, onChange, value, className, startAdornment, of, valueProperty, multiline, loadingImage, preConvertValueFn, postConvertValueFn, loadingImageClassName, labelIcon } = _a, restProps = __rest(_a, ["name", "type", "label", "placeholder", "helperText", "onChange", "value", "className", "startAdornment", "of", "valueProperty", "multiline", "loadingImage", "preConvertValueFn", "postConvertValueFn", "loadingImageClassName", "labelIcon"]);
    // const [inputType, setInputType] = useState('text');
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const onBlur = (e) => {
        let value = e.currentTarget.value;
        if (!of)
            return;
        if (postConvertValueFn) {
            value = postConvertValueFn(value);
        }
        of[valueProperty] = value;
        //show a loading indicator to the user so they know their data is being saved
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };
    const onChangeHandler = (e) => {
        if (onChange) {
            onChange(e);
        }
    };
    return (react_1.default.createElement("div", { className: InputField_scss_json_1.default.inputContainer },
        label && (react_1.default.createElement("div", { className: InputField_scss_json_1.default.labelContainer },
            labelIcon && labelIcon,
            react_1.default.createElement("label", null, label))),
        react_1.default.createElement(Input_1.Input, Object.assign({ type: type, name: name, value: value, startAdornment: startAdornment, multiline: multiline, placeholder: placeholder, onChange: onChangeHandler, defaultValue: of
                ? preConvertValueFn
                    ? preConvertValueFn(of[valueProperty])
                    : of[valueProperty]
                : '', onBlur: onBlur, slotProps: {
                input: {
                    className: (0, ClassNames_1.cl)(className, InputField_scss_json_1.default.input),
                },
            } }, restProps)),
        helperText && react_1.default.createElement("p", { className: InputField_scss_json_1.default.helperText }, helperText),
        isLoading && (react_1.default.createElement("img", { src: loadingImage || '/images/spinner-blue.gif', alt: "loading", className: (0, ClassNames_1.cl)(InputField_scss_json_1.default.spinner, loadingImageClassName) }))));
};
exports.InputField = InputField;
//# sourceMappingURL=InputField.js.map